import { Button } from '@neo/index'
import { formatDurationForDisplay } from '@shared/utils'
import dayjs from 'v2/utils/dayjs'
import { useAudioPlayer } from '../contexts/audio-player-context'
import { AUDIO_SEEK_OFFSET } from './constants'

interface DurationProps {
  timestamp: string
  firstEventTimestamp: string
}

export const DurationRenderer = ({ timestamp, firstEventTimestamp }: DurationProps) => {
  const { seekToTime } = useAudioPlayer()

  const timeDiffInSeconds = dayjs.utc(timestamp).diff(dayjs.utc(firstEventTimestamp), 'seconds')
  const timestampDiff = formatDurationForDisplay(timeDiffInSeconds)

  const onClickDuration = () => {
    const target = Math.max(0, timeDiffInSeconds - AUDIO_SEEK_OFFSET)
    seekToTime(target)
  }

  return (
    <Button
      variant="ghostLink"
      className="ring-transparent p-0 h-fit font-jetbrains text-xs-400 tabular-nums tracking-normal normal-case text-secondary ring-offset-0"
      onClick={onClickDuration}
      data-testid="duration-seek-button"
    >
      {timestampDiff}
    </Button>
  )
}
